import { render, staticRenderFns } from "./Admission.vue?vue&type=template&id=7ab8de18&scoped=true"
import script from "./Admission.vue?vue&type=script&lang=js"
export * from "./Admission.vue?vue&type=script&lang=js"
import style0 from "./Admission.vue?vue&type=style&index=0&id=7ab8de18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab8de18",
  null
  
)

export default component.exports